import { render, staticRenderFns } from "./AccountingGivenList.vue?vue&type=template&id=a0e5e8ae&scoped=true&"
import script from "./AccountingGivenList.vue?vue&type=script&lang=js&"
export * from "./AccountingGivenList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingGivenList.vue?vue&type=style&index=0&id=a0e5e8ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e5e8ae",
  null
  
)

export default component.exports